import { marxy } from '../initMarxy'
import { MarxyEvents, MarxyCategoryData } from '~/utils/marxy/types'

/**
 * Tracks category view - on category page
 */
const trackViewCategory = (marxyCategoryData: MarxyCategoryData) => {
  try {
    const categoryData = {
      categories_list: marxyCategoryData.categoriesList,
      category_id: marxyCategoryData.categoryId,
      category_title: marxyCategoryData.categoryTitle,
      path: marxyCategoryData.categoryUrl,
    }
    marxy.trackEvent(MarxyEvents.VIEW_CATEGORY, categoryData)
  } catch (error) {
    throw new Error(
      `Marxy viewItem: Compile event data failed because [${error.message}]`
    )
  }
}

export default trackViewCategory
